import { Component, ViewChild, ElementRef, OnDestroy, TemplateRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CorrectedHttpClient } from '@infrastructure/http/corrected-http-client'
import { ActivatedRoute, Router, ParamMap, NavigationExtras, NavigationEnd, NavigationStart, RouterEvent, ActivationStart } from '@angular/router';
import { map, mergeMap, switchMap, filter, tap, catchError } from 'rxjs/operators';
import { Subject, ReplaySubject, Observable, Subscription, of, throwError, combineLatest } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslateService } from '@ngx-translate/core';
import { StepComponentNew } from './step-new.component';
import { AlertService } from '@infrastructure/Alerts/alert.service';
import { StepStateCodes } from "../../models/const.Contants";
import { NgForm } from '@angular/forms';
import { ExternalValidationsService } from '@infrastructure/ValidationMessages/ExternalValidationsService';
import { PermissionConstants } from '../../models/const.PermissionConstants';
import { BsLocaleService } from 'ngx-bootstrap/datepicker'
import { defineLocale } from 'ngx-bootstrap/chronos';
import { ptBrLocale } from 'ngx-bootstrap/locale';
import { ModalService } from '@infrastructure/Modal/ModalService';
import { VisualActions } from "../../models/const.Contants";
import { SystemInformationService } from '@infrastructure/SystemInformation/SystemInformationService';
import { SecurityService } from '@infrastructure/Security/SecurityService';
import { isNullOrUndefined, isNotNullOrUndefinedOrEmpty, isNullOrUndefinedOrEmpty } from '@infrastructure/objectUtils';
import { LoadingMaskService } from '@infrastructure/LoadingMask/LoadingMaskService';
import { StepDetailsService } from '@infrastructure/StepDetailsService/StepDetailsService';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { LogType } from '../../models/const.LogModelVM';
import { LogService } from '@infrastructure/log/LogService';
import { CacheService } from '@infrastructure/Cache/CacheService';
import { DocumentVMExtension } from './cards/Documentation/IDocumentation';

import { PrestacoesMorteValueObservableService } from '@infrastructure/Documents/PrestacoesPorMorteValueObserver';
import DateHelpers from '@infrastructure/DateHelpers';
import { DropdownsValues } from '@infrastructure/Dropdowns/const.dropdowns';
import { DocumentosObservableService } from '@infrastructure/Documents/DocumentosObservable';
import { scrollToTop } from '@infrastructure/screenUtils';
import { PersonType } from '@infrastructure/Models/const.personType';

import { BeneficiaryHelperService } from '@infrastructure/Beneficiaries/BeneficiaryHelperService';
import ArrayHelpers from '@infrastructure/ArrayHelper';

import { SessionStorageService } from '@infrastructure/SessionStorageService/SessionStorageService';
import { BeneficiaryValuesService } from '@infrastructure/Beneficiaries/beneficiary-values.service';
import { LegalRepresentationState } from '../_infrastructure/Beneficiaries/legal-representation-state.service';

@Component({
  selector: 'workflow-new',
  templateUrl: './workflow-new.component.html',
  styleUrls: ['./workflow-new.component.scss'],
  standalone: false
})



export class WorkflowComponentNew implements OnDestroy {

  @ViewChild('errorsFound') errorsFound: TemplateRef<any>;
  modalRef: BsModalRef;

  public cardData: models.SendWorkflowVM = {} as models.SendWorkflowVM;
  public lastCurrentStep: string;
  public isReturn: boolean = false;
  public isDisabled: boolean = false;
  public workflowInstanceLoaded: boolean = false;
  readonly VisualActions = VisualActions;
  //BUSINESS
  public domain: string;
  public currentStep: StepComponentNew;
  public workflowInstanceId: string; // Recebido da rota
  public steps: models.StepVM[] = [];
  public workflowTemplate: models.WorkflowTemplateVM = {} as models.WorkflowTemplateVM;
  public workflowInstance: models.WorkflowTemplateVM_PM = {} as models.WorkflowTemplateVM_PM;
  public workFlowErrors: models.WorkflowValidationsVM = {} as models.WorkflowValidationsVM;
  public showReturnButton: boolean;
  public mainSubscription: Subscription = new Subscription();
  public workflowDropdowns: models.WorkflowDropdownsVM = {} as models.WorkflowDropdownsVM;
  //public workflowMandatoryDocs: models.DocumentVM[] = [];
  public workflowVersion: any;
  

  public isAtendimento: boolean;
  public nextMenuStep: string;
  public canApagarCTO: boolean = false;

  private personTypologyValues = DropdownsValues.dropDownPersonType;
  private relationWithDesceasedValues = DropdownsValues.dropdownDeceasedRelationship;
  private scholarSituationValues = DropdownsValues.dropListScholarSituationDeathDate;
  private isAddingNotifications: boolean = false;


  public destinoRouter: string;

  //NAVIGATION
  public currentStepIndex = 0;
  public statePhase: string;
  public stateCode: string;
  public instanceRole: string;
  public get currentPercentage() { return this.currentStepIndex != 0 ? 1 - (this.currentStepIndex / this.steps.length) : 1 };

  public get SubscriberNumber() {
    let result = "";
    switch (this.workflowCode) {
      case 'PEDI002B':
      case 'PEDI002A':
      case 'PEDI002':
        result = this.workflowInstance.StepDeceased?.DeceasedIdentification?.subscriberNumber.toString();
        break;
    }
    return result;
  }

  public get UserNumber() {
    let result = "";
    switch (this.workflowCode) {
      case 'PEDI002':
        result = this.securityService.userDetails.userId.toString();
        break;
    }
    return result;
  }

  public get isLastStep() {
    return this.currentStepIndex >= this.steps.length - 1;
  }
  public get isFirstStep() {
    return ((this.currentStepIndex) || 0) <= 0;
  }
  public get isNextDisabled() {
    return this.isDisabled ;
  }




  public get isCurrentStepLoaded() {
    return this.currentStep?.isStepLoaded;
  }

  public get currentStepDefinition(): models.StepVM {
    return this.steps[this.currentStepIndex];
  }

  public get isWorkflowSubmited() {
    if ((this.stateCode == 'C' && this.statePhase == 'C') || (this.stateCode == 'I' && this.statePhase == 'RLI')) {
      return true;
    }
    return false; // this.workflowInstance?.stateCode === "C"; // TODO: Ver com BE
  }


  public get isPrestageWorkflowSubmited() {
    if (this.stateCode == 'P' && this.statePhase == 'PVR') {
      return true;
    }
    return false; // this.workflowInstance?.stateCode === "C"; // TODO: Ver com BE
  }

  public get isWorkflowOnSubscriber() {
    if (this.isAtendimento)
      return false;// this.workflowInstance.instanceRole == '007' ? true : false; // TODO: Ver com BE

    else
      return false; //VER COM O JOÂO //this.securityService.userHasPermission(PermissionConstants.WorkflowEditPage.editSubscriberData);
  }

  public get isWorkflowPgpv() {
    return this.securityService.isUserPgpv();
  }

  public get canUserSaveData() {
    return this.securityService.canUserSaveData();
  }

  @ViewChild('cgaWorkflowForm')
  private cgaWorkflowForm: NgForm;

  @ViewChild('cgaGetFileForm', { read: ElementRef }) cgaGetFileForm: ElementRef;

  private _initialized: Subject<void> = new ReplaySubject<void>();
  // Esta propriedade serve para os steps filhos terem uma guarda que lhes permita saber se o pai já carregou os dados
  public get initialized(): Observable<void> {
    return this._initialized.asObservable();
  }

  public workflowCode: string;


  constructor(private localeService: BsLocaleService, private http: CorrectedHttpClient, private activeRoute: ActivatedRoute, private router: Router, private alertService: AlertService,
    private translate: TranslateService, private externalValidationsService: ExternalValidationsService, private modalService: ModalService, private bsModalService: BsModalService,
    private systemInformationService: SystemInformationService, private securityService: SecurityService,
    private loadingMaskService: LoadingMaskService, private stepDetailsService: StepDetailsService,
    private logService: LogService,
    private cacheService: CacheService,
    private prestacoesPorMorteValue: PrestacoesMorteValueObservableService,
    private documentsObservableService: DocumentosObservableService,
    private beneficiaryHelperService: BeneficiaryHelperService,
    private sessionStorageService: SessionStorageService,
    private route: Router,
    private beneficiariesValues: BeneficiaryValuesService
    
  ) {
      this.documentsObservableService.removeAllNotifications();

      // This is to enforce that notications are loaded as soon as we change step
      this.mainSubscription.add( this.route.events.pipe(
        filter(el => (el instanceof ActivationStart) && !!this.workflowInstance )
      ).subscribe(queryParams => {
        const url = (<any>queryParams)?.snapshot.url;
        const path = (<any>queryParams)?.snapshot.routeConfig?.path;
        if (!!url && path == "step/:currentStepCode") {
          const foundStep = url[url.length-1].path;
          if (this.isStepAfterOrCurrentForceStep(foundStep)) {
            this.loadDocumentNotificationPEDI002(foundStep);
          }
        }
      }));
      this.activeRoute.paramMap.subscribe((params: ParamMap) => {
      this.workflowInstanceId = params.get('workflowInstanceId');
        this.workflowCode = params.get('workflowCode');
        this.stepDetailsService.newWorkFlowCode(this.workflowCode);

      if (this.workflowInstanceId !== undefined) {
        this.loadingMaskService.setShowLoading(true, true, null);

        this.isAtendimento = ((this.securityService.userDetails.informationGroups.includes("PGPA") ? "A" : null) == "A" ? true : false);

        // No fim da leitura dos dados notificamos os subscritores do fim do carregamento através do Subject initialized
        this.loadWorkflowInstance()
          .subscribe(() => {
            if (this.isWorkflowSubmited) {
              //this.addDocumentsToNotifications();
              this.documentsObservableService.setWorkflowSubmited(true);
            } else {
              this.saveBeneficiariesValues();
              this.documentsObservableService.setWorkflowSubmited(false);

              if (this.workflowCode == "PEDI002" || this.workflowCode == "PEDI002A" || this.workflowCode == "PEDI002B") { // para precarregar os documentos
                this.loadDocumentNotificationPEDI002()
              }
            }


            this.loadWorkflowDropdowns().subscribe(result => {



                this.workflowDropdowns = result;
                this._initialized.next();
                this.hideLoadingMask();
                this.workflowInstanceLoaded = true;
                this.hideLoadingMask();
                let workflowCode = this.workflowCode;
                if (parseInt(this.workflowVersion) >= 3) {
                  workflowCode = this.workflowCode;
                }
                this.stepDetailsService.newWorkFlowCode(workflowCode);
                if (workflowCode == "PEDI0020B") {
                  const habilitaApagarCto: models.HabilitaApagarCtoVM = {
                    workflowInstanceId: this.workflowInstanceId,
                    workflowCode: workflowCode
                  };
                  this.http.post<models.WorkflowStatusVM>("api/Workflow/HabilitaApagarCto", habilitaApagarCto)
                    .subscribe((result: models.WorkflowStatusVM) => {
                      if (result.stateCode == "OK") {
                        this.canApagarCTO = result.allowDelete;
                      } else {
                        this.alertService.error(result.message)
                      }
                    }, () => this.hideLoadingMask());
                } else {
                  this.canApagarCTO = true;
                }
              }, () => { if (parseInt(this.workflowVersion) >= 2) this.hideLoadingMask() });
          }, () => this.hideLoadingMask())
      }
    });


    this.mainSubscription.add(this.stepDetailsService.needsRevisionSubject.subscribe(result => this.showReturnButton = result));
    //const messageProp = this.translate.instant('Generic.DatePickerPlaceholder');

    const messageProp = this.translate.instant('Generic.DatePickerPlaceholder');
    ptBrLocale.invalidDate = messageProp;
    defineLocale('custom locale', ptBrLocale);
    this.localeService.use('custom locale');

    this.loadSystemInfo();

    //Observar os documentos que são obrigatórios no PEDI002
    this.mainSubscription.add(
      this.documentsObservableService.notifications
        .subscribe(docs => {
          if (docs !== null) {

            docs.forEach(doc => {

              const existeDoc = this.workflowInstance?.StepDocumentsPM?.DocumentationPM?.documentsList
                .find(el => el.designationTypeCode == doc.documentTipologyCode &&
                  //el.nif == doc.ownerNif &&
                  el.beneficiaryID == doc.beneficiaryID &&
                  el.fileOwnerTypeCode == doc.ownerCode);
              //if (existeDoc && existeDoc.fileID > 0) {
              //  this.documentsObservableService.markDocumentExist(doc);
              //}
              if (existeDoc == null || existeDoc == undefined) {
                const newDoc: models.DocumentPM_VM = {
                  designationTypeCode: doc.documentTipologyCode,
                  designationTypeDescription: doc.documentTipologyDescription,
                  beneficiaryID: this.documentsObservableService.getBeneficiaryByNIF(
                    this.workflowInstance.StepBeneficiary?.Beneficiary?.beneficiaryList,
                    doc.ownerNif, doc.ownerName, doc.ownerCode),
                  ownerName: doc.ownerName,
                  fileOwnerTypeCode: doc.ownerCode,
                  isMandatoryFile: true,
                  isNecessary: true,
                  nif: doc.ownerNif


                } as models.DocumentPM_VM;
                this.workflowInstance.StepDocumentsPM.DocumentationPM.documentsList.push(newDoc);

              } else {
                existeDoc.designationTypeDescription = doc.documentTipologyDescription;
                existeDoc.beneficiaryID = this.documentsObservableService.getBeneficiaryByNIF(
                  this.workflowInstance.StepBeneficiary.Beneficiary.beneficiaryList,
                  doc.ownerNif, doc.ownerName, doc.ownerCode);
                existeDoc.ownerName = doc.ownerName;
                existeDoc.designationTypeCode = doc.documentTipologyCode;
                existeDoc.designationTypeDescription;
                existeDoc.fileOwnerTypeCode = doc.ownerCode;
                existeDoc.isMandatoryFile = true;
                existeDoc.isNecessary = true;
                existeDoc.nif = doc.ownerNif;

              }

            });

          }
        })
    );

    //Observar os documentos que são para apagar no PEDI002
    this.mainSubscription.add(
      this.documentsObservableService.toDelete
        .subscribe(doc => {
          if (doc != null && doc != undefined) {
            const existeDoc = this.workflowInstance.StepDocumentsPM.DocumentationPM.documentsList
              .find(el => el.designationTypeCode == doc.documentTipologyCode &&
                //el.nif == doc.ownerNif &&
                el.beneficiaryID == doc.beneficiaryID &&
                el.fileOwnerTypeCode == doc.ownerCode);
            //if (existeDoc && existeDoc.fileID > 0) {
            //  this.documentsObservableService.markDocumentExist(doc);
            //}
            if (existeDoc != null || existeDoc != undefined) {
              this.workflowInstance.StepDocumentsPM.DocumentationPM.documentsList =
                ArrayHelpers.removeItem(this.workflowInstance.StepDocumentsPM.DocumentationPM.documentsList, existeDoc);
            }
          }

        })
    );


  }

  //private  addDocumentsToNotifications() {
  //  // Adiciona às notificações os documentos mandatórios
  //  const documentosObrigatorios = this.workflowInstance.StepDocumentsPM.DocumentationPM
  //    .documentsList.filter(el => el.isMandatoryFile);
  //  documentosObrigatorios.forEach((doc: models.DocumentPM_VM) => {
  //    this.

  //  })
  //}


  saveBeneficiariesValues(): any {
    this.workflowInstance.StepBeneficiary.Beneficiary.beneficiaryList?.forEach(beneficiary => {
      this.beneficiariesValues.setBeneficiaryValues(beneficiary);
    });
  }

  private isDocumentOwner(ownerTypeCode: string, fileOwnerTypeCode: string): boolean {
    let result = ownerTypeCode == fileOwnerTypeCode;
    return result;
  }

  public isHabilitandosListOk(): boolean {
    let result = true;
    if (this.currentStepCode != "StepBeneficiary") {
      return true;
    }
    this.workflowInstance.StepBeneficiary.Beneficiary.beneficiaryList?.forEach((el: models.BeneficiaryListVM) => {
      result = result && this.beneficiaryHelperService.isBeneficiaryValid(el);
    });
    return result;
  }

  ngOnInit(): void {
    // PIT 40803 \\
    const validOption = ['/instancebrowser', '/workflowSearch'];

    const dadosOrigem = this.sessionStorageService.getOrigemPedidoOptionOnCache();

    if (dadosOrigem != null && validOption.includes(dadosOrigem.origemDoAcesso)) {
      this.destinoRouter = dadosOrigem.origemDoAcesso;
    }
    else {
      this.destinoRouter = '/workflowSearch';
    }
    // PIT 40803 \\
  }

  ngOnDestroy(): void {
    this.mainSubscription.unsubscribe();
    this.stepDetailsService.emitNeedsRevisionChange(false);
    this.stepDetailsService.newCurrentStep(undefined);
    this.stepDetailsService.workFlowCode.next(null);
    this.documentsObservableService.removeAllNotifications();

  }

  public loadSystemInfo() {
    this.systemInformationService.loadCurrentSystemInformation().subscribe(result => {
      this.domain = this.securityService.userDetails.refererDomain + result.fileTransfer;
      //this.domain = result.cgaDirecta + result.fileTransfer;
    });
  }

  // Para ser chamado pelo filho quando tiver terminado a inicialização dos cartões
  activateStep(currentStep: StepComponentNew) {
    if (currentStep.currentStepCode != this.steps[this.steps.length - 1].stepCode && this.isReturn) {
      this.isReturn = false;
    }
    this.currentStep = currentStep;
    if (this.currentStep !== undefined) {
      this.currentStepIndex = this.steps.findIndex(step => step.stepCode === currentStep.currentStepCode);
      this.stepDetailsService.newCurrentStep(currentStep.currentStepCode);
    }
    //this.isDisabled = (!this.isLastStep) ? false : true;
    this.isDisabled = (!this.steps);

  }

  //COMPONENT RELATED METHODS
  /**
  * Got to next step, save data from current step
  *
  * @remarks
  * This is the workflow module interface.
  *
  */

  public preStepNext() {
    if (this.isWorkflowSubmited || this.isPrestageWorkflowSubmited || !this.canUserSaveData) {
      this.navigateToStep(false);
      this.hideLoadingMask();
      this.isDisabled = (!this.isLastStep) ? false : true;
      return;
    }
    else if (this.currentStepCode == "StepDeceased") {
      //Se existe um habilitando com survivalPensinBenefit
      const existeBeneficioSobrevivencia = this.workflowInstance.StepBeneficiary.Beneficiary
        .beneficiaryList?.filter(item => item.survivalPensionBenefit?.toString() == 'true').length>0;
      //Notificação do campo "Estava a receber uma pensão de aposentação/reforma pela CGA à data de obito?"
      //if (existeBeneficioSobrevivencia && this.workflowInstance.StepDeceased?.ProfessionalCategory?.hadPensionCGABeforeDeath?.toString().toLowerCase() == 'false' ) {
      //  this.isDisabled = false
      //  var confirmDeleteModal = <models.BaseModalVM>{
      //    isError: false,
      //    message: "PrestacoesMorte.Modals.ProfessionalCategory.CGAPensionWarning",
      //    cancelButton: {
      //      hideButton: true,
      //      buttonText: "Ok",
      //      buttonClass: 'btn-primary',
      //      iconClass: "icon-check"
      //    }
      //  };
      //  this.modalService.showModals([confirmDeleteModal]).subscribe(resultSubscribe => {
      //    if (resultSubscribe == true) {
      //      this.onStepNext();
      //    }
      //  })
      //} else {
        this.onStepNext();
      //} 
    } else {
      this.onStepNext();
    }
  }

  public async onStepNext() {
    this.isDisabled = true;
    this.loadingMaskService.setShowLoading(true, false);
    this.alertService.clear();



    if (this.isWorkflowSubmited || !this.canUserSaveData) {
      this.navigateToStep(false);
      this.hideLoadingMask();
      this.isDisabled = (!this.isLastStep) ? false : true;
      return;
    }
    else {
      //Preciso setar o touched no Next para forçar o display de errors e validações
      //Uma vez que não desejavam que estas estivessem visiveis ao carregar a aplicãçao
      const invalidFields: string[] = [];
      Object.keys(this.cgaWorkflowForm.controls).forEach(controlKey => {
        this.cgaWorkflowForm.controls[controlKey].markAsTouched();
        if (this.cgaWorkflowForm.controls[controlKey].invalid) {
          invalidFields.push(controlKey);
        }
      })

      if (this.cgaWorkflowForm.invalid) {
        this.isDisabled = (!this.isLastStep) ? false : true;
        this.showErrorModalAndScroll();
        this.hideLoadingMask();
        this.isDisabled = (!this.isLastStep) ? false : true;
        return;
      }



      this.writeToLog('WorkFlow Instance: ' + this.workflowInstanceId + ' <-> ' + this.workflowCode + ' | WorkComponent | onStepNext -> RefreshWorkFlowDataFromUI', LogType.Debug);
      this.RefreshWorkFlowDataFromUI();
      this.loadingMaskService.setShowLoading(true, false);
      var stepInvalid = false;


      //Validar se existem step anteriores não validados
      for (var index = 0; index < this.currentStepIndex; index++) {
        if (this.steps[index].stateCode == "PV" || this.steps[index].stateCode == "E") {
          stepInvalid = true;
          break;
        }
      }

      if (stepInvalid) {
        this.alertService.error("Existem passos anteriores que não se encontram validados. Por favor complete e valide a informação.");
        window.scrollTo(0, 0);
        this.hideLoadingMask();
        this.isDisabled = (!this.isLastStep) ? false : true;
        return;
      }

      this.lastCurrentStep = this.activeRoute.firstChild.snapshot.params['currentStepCode'];
      var lastCurrentStepIndex = this.steps.findIndex(i => { return i.stepCode == this.lastCurrentStep });
      this.writeToLog('WorkFlow Instance: ' + this.workflowInstanceId + ' <-> ' + this.workflowCode + ' | WorkComponent | onStepNext -> validateStepData', LogType.Debug);
      if (this.lastCurrentStep == "StepDocuments") {
        const arrayDocs: DocumentVMExtension[] = (this.workflowInstance.StepDocumentsPM as any).ServDocumentation?.documentsList;
        const arrayMandatoryDocs: DocumentVMExtension[] = (this.workflowInstance.StepDocumentsPM as any).DocumentationMandatory?.documentsList;
        let allDocs = [];
        if (arrayDocs !== null && arrayDocs !== undefined) {
          allDocs = allDocs.concat(arrayDocs);
        }
        if (arrayMandatoryDocs !== null && arrayMandatoryDocs !== undefined) {
          allDocs = allDocs.concat(arrayMandatoryDocs);
        }

        const result = this.isDocumentationOk(allDocs);
        if (!result) {
          this.isDisabled = (!this.isLastStep) ? false : true;
          return;
        }
      }

      
      
      (await this.validateStepData()).pipe(
        filter(() => this.currentStepDefinition.stateCode === "V"),
        switchMap(() => {
          let $result = null;
          $result = this.http.post<void>('api/Workflow/SaveWorkflowInstance_PM', this.workflowInstance, { params: { workflowInstanceId: this.workflowInstanceId, workflowCode: this.workflowCode } });
          

          return $result;
        }
        ),
      ).subscribe(
        () => {
          this.writeToLog('WorkFlow Instance: ' + this.workflowInstanceId + ' <-> ' + this.workflowCode + ' | WorkComponent | onStepNext -> validateStepData Subscribe navigateToStep - Start', LogType.Debug);
          this.navigateToStep(false);
          this.alertService.success("Workflow.NextSaveSucess");
          this.writeToLog('WorkFlow Instance: ' + this.workflowInstanceId + ' <-> ' + this.workflowCode + ' | WorkComponent | onStepNext -> validateStepData Subscribe navigateToStep - End', LogType.Debug);
          this.isDisabled = (!this.isLastStep) ? false : true;

        },
        error => {
          console.log(error);
          this.isDisabled = (!this.isLastStep) ? false : true;
          this.hideLoadingMask();
        },
        () => {
          this.hideLoadingMask();
          this.isDisabled = (!this.isLastStep) ? false : true;
        },
      );
    }

    this.writeToLog('WorkFlow Instance: ' + this.workflowInstanceId + ' <-> ' + this.workflowCode + ' | WorkComponent | onStepNext -> exit', LogType.Debug);
  }

  private detectScrollbarVerticalNeed() {
    const body = document.body;
    const needForScroll = body.getBoundingClientRect().top < 0;
    if (needForScroll) {
      body.classList.add("scroll-need");
    } else {
      body.classList.remove("scroll-need");
    }

  }

  private showErrorModalAndScroll() {
    this.detectScrollbarVerticalNeed();
    window.scrollTo(0, 0);
    (<any>document.activeElement).blur();
    this.modalRef = this.bsModalService.show(
      this.errorsFound,
      Object.assign({}, { class: 'modal-lg' }));

    this.mainSubscription.add(
      this.modalRef.onHide.subscribe(res =>
        this.detectScrollbarVerticalNeed()
      )
    );

    this.isDisabled = (!this.isLastStep) ? false : true;
  }

  private navigateToStep(goBack: boolean) {
    this.writeToLog('WorkFlow Instance: ' + this.workflowInstanceId + ' <-> ' + this.workflowCode + ' | WorkComponent | navigateToStep - Start', LogType.Debug);
    const indexIncrement = goBack ? -1 : 1;
    const nextCode = this.steps[this.currentStepIndex + indexIncrement].stepCode;

    if (goBack && !this.isAtendimento)
      this.menuSideBarClick(nextCode);


    this.router.navigate(['step', nextCode], {
      relativeTo: this.activeRoute
    }).then(res => {
      if (res) {
        this.currentStepIndex = this.steps.findIndex(step => step.stepCode === nextCode);

        window.scrollTo(0, 0);
        this.writeToLog('WorkFlow Instance: ' + this.workflowInstanceId + ' <-> ' + this.workflowCode + ' | WorkComponent | navigateToStep - End', LogType.Debug);
        if (!goBack) {
          if (this.workflowCode == "PEDI002" || this.workflowCode == "PEDI002A" || this.workflowCode == "PEDI002B") {
            this.loadDocumentNotificationPEDI002();
          }
        }
      }

    });
  }
  /**
  * Got to precious step, save data from current step
  *
  * @remarks
  * This is the workflow module interface.
  *
  */
  public onStepBefore() {
    if (this.currentStepCode == "StepDocuments") {
      const arrayDocs: DocumentVMExtension[] = (this.workflowInstance.StepDocumentsPM as any).ServDocumentation?.documentsList;
      const arrayMandatoryDocs: DocumentVMExtension[] = (this.workflowInstance.StepDocumentsPM as any).DocumentationMandatory?.documentsList;
      let allDocs = [];
      if (arrayDocs !== null && arrayDocs !== undefined) {
        allDocs = allDocs.concat(arrayDocs);
      }
      if (arrayMandatoryDocs !== null && arrayMandatoryDocs !== undefined) {
        allDocs = allDocs.concat(arrayMandatoryDocs);
      }

      const result = this.isDocumentationOk(allDocs, false);
      if (!result) {
        var confirmDeleteModal = <models.BaseModalVM>{ isError: false, message: "Workflow.DocumentsToBeSubmitted" };
        return this.modalService.showModals([confirmDeleteModal]).subscribe(resultSubscribe => {
          if (!resultSubscribe) {
            return;
          }
          else {
            this.writeToLog('WorkFlow Instance: ' + this.workflowInstanceId! + ' <-> ' + this.workflowCode + ' | WorkComponent | onStepBefore -> RefreshWorkFlowDataFromUI', LogType.Debug);
            this.RefreshWorkFlowDataFromUI();

            if (this.isReturn) {
              this.router.navigate(['workflow/', this.workflowInstanceId, 'step', this.lastCurrentStep]);
              this.isReturn = false;
            } else {
              this.navigateToStep(true);
            }
          }
        });
      }
    }
    this.writeToLog('WorkFlow Instance: ' + this.workflowInstanceId! + ' <-> ' + this.workflowCode + ' | WorkComponent | onStepBefore -> RefreshWorkFlowDataFromUI', LogType.Debug);
    this.RefreshWorkFlowDataFromUI();

    if (this.isReturn) {
      this.router.navigate(['workflow/', this.workflowInstanceId, 'step', this.lastCurrentStep]);
      this.isReturn = false;
    } else {
      this.navigateToStep(true);
    }
  }

  //INTERNAL API CALLS
  /**
  * Search for a workflow instance for a given subscriber
  *
  * @remarks
  * This is an api call 
  *
  */
  public loadWorkflowInstance() {


    const $workflowInstance: Observable<models.InstancePMWithStatusVM> =
      this.http.get<models.InstancePMWithStatusVM>('api/Workflow/LoadWorkflowInstance_PM',
        { params: { workflowInstanceId: this.workflowInstanceId, workflowCode: this.workflowCode } });


    let $workflowTemplate: Observable<models.WorkflowTemplateNewVM> =
      this.http.get<models.WorkflowTemplateNewVM>('api/Workflow/LoadWorkflowTemplate_PM',
        { params: { workflowInstanceId: parseInt(this.workflowInstanceId), workflowCode: this.workflowCode } });

    const $bothObservables = combineLatest($workflowInstance, $workflowTemplate);
    return $bothObservables.pipe(
      mergeMap(([wfi, wft]) => {

        this.workflowInstance = wfi.instance;
        this.stateCode = wfi.stateCode;
        this.statePhase = wfi.statePhase;
        this.instanceRole = wfi.instanceRole;
   

        this.workflowVersion = '3'// TODO: Falar com @Sisto --wfi.version as any;

        if (wfi) {


          let workflowsInformations$: Observable<models.WorkflowInformationVM> =
            this.http.get<models.WorkflowInformationVM>('api/Workflow/LoadWorflowInformation', { params: { workflowInstanceId: this.workflowInstanceId, workflowCode: this.workflowCode } });


          const workflowsHelpLinks$: Observable<models.WorkflowHelpLinkVM[]> =
            this.http.get<models.WorkflowHelpLinkVM[]>('api/Workflow/LoadWorkflowsHelpLinks', {});

          return combineLatest(workflowsInformations$, workflowsHelpLinks$)
            .pipe(
              filter(([workflowsInformations, workflowsHelpLinks]) => workflowsInformations !== null && workflowsHelpLinks !== null),
              map(([workflowsInformation, workflowsHelpLinks]) => {
                if (!this.isNumeric(workflowsInformation.workFlowHelpLink) && workflowsInformation.workFlowHelpLink.length > 0) {
                  const foundEntry = workflowsHelpLinks.find(wh => wh.codigo == workflowsInformation.workFlowHelpLink);
                  if (foundEntry !== null && foundEntry !== undefined) {
                    workflowsInformation.workFlowHelpLink = foundEntry.refFichId.toString();
                  } else {
                    const logModel: models.LogModelVM = {
                      message: `Could not found refFichId for workFlowHelpLink: ${workflowsInformation.workFlowHelpLink}`,
                      type: LogType.Error
                    };
                    this.logService.logToBackend(logModel);
                    this.cacheService.cacheMissingHelpLink(workflowsInformation.workflowCode);
                  }

                }

                return workflowsInformation;
              }),
              mergeMap((wfinfo, index) => {
                this.workflowTemplate = { ...wfinfo } as models.WorkflowTemplateVM;
                //const isExSubscritor = (this.workflowCodeParameter.indexOf('PEDI008') == -1 &&
                //  this.workflowCodeParameter.indexOf('PEDI005') == -1) ? false : true;
                const isExSubscritor = false;



                let filteredSteps = [];
                for (let i = 0; i < wft.steps.length; i++) {
                  if (wft.steps[i].stepCode !== "StepPrestagePM") {
                    filteredSteps.push(wft.steps[i]);
                  }
                }



                this.workflowTemplate.steps = filteredSteps;
                this.steps = filteredSteps;

                Object.keys(this.cgaWorkflowForm.controls).forEach(controlKey => {
                  this.cgaWorkflowForm.controls[controlKey].disable();
                })

                    // Não vamos validar se a rota bate certo com a definição de steps do workflow
                    // Isso é um erro e como tal deve estoirar
                    // Mesmo que validássemos nunca saberíamos resolver a situação, lançar alerta ao utilizador e depois?
                    // A fazer alguma validação será sempre no filho
                return of(true);
                
           
              })
            );

          //console.log(`Loaded workFlow Instance Id: ${this.workflowInstanceId}`, this.workflowInstance)


        }
      }));
    
  }


  private isNumeric(str: string): boolean {
    if (typeof str != "string") return false; // we only process strings!
    if (str === null || str === undefined) return false; // null or undefineds are not numbers
    if (str.length === 0) return false; // empty string are not numbers
    return !isNaN(str as any) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
      !isNaN(parseFloat(str)) // ...and ensure strings of whitespace fail
  }

  public loadWorkflowDropdowns() {

    return this.http.get<models.WorkflowDropdownsVM>('api/Workflow/LoadWorkflowDropdowns', { params: { workflowInstanceId: this.workflowInstanceId, workflowCode: this.workflowCode } })
      .pipe(
        tap((res: models.WorkflowDropdownsVM) => this.prestacoesPorMorteValue.assignateDropdowns(res))
      );

  }

  /**
* Persist card information for the workflow.
*
* @remarks
* This is the workflow module interface.
*
*/
  public onSaveWorkflowData(event: Event) {
    // Como este é o primeiro botão do Form o angular decide que é um submit
    // assim temos que evitar o comportamento default, senão faz refresh à pagina
    event.preventDefault();

    //REFRESH DATA FROM STEPS
    this.writeToLog('WorkFlow Instance: ' + this.workflowInstanceId + ' <-> ' + this.workflowCode + ' | WorkComponent | onSaveWorkflowData -> RefreshWorkFlowDataFromUI', LogType.Debug);
    this.RefreshWorkFlowDataFromUI();
    this.loadingMaskService.setShowLoading(true, false);

    if (this.workflowInstance.StepDeceased.DeceasedIdentification.identificationDocumentType == 'B') {
      this.workflowInstance.StepDeceased.DeceasedIdentification.identificationNumberFirst = this.workflowInstance.StepDeceased.DeceasedIdentification.identificationNumberFirst?.replace(/^0+/, '');
    }

    this.http.post<models.WorkflowStatusVM>('api/Workflow/SaveWorkflowInstance_PM', this.workflowInstance, { params: { workflowInstanceId: this.workflowInstanceId, workflowCode: this.workflowCode } })
      .subscribe((wf: models.WorkflowStatusVM) => {
        this.alertService.clear();
        if (wf.stateCode == <string>"OK") {
          if (this.workflowCode.indexOf("PEDI0020") > -1) {
            this.alertService.success("Workflow.SaveSucessCT")
          } else {
            this.alertService.success("Workflow.SaveSucess")
          }
        }
        else {
          this.alertService.error(wf.message)
        }
        this.hideLoadingMask();
        scrollToTop();
      },
        error => this.hideLoadingMask()
      );
  }

  reloadPage() {
    this.router.navigateByUrl(`/workflow/${this.workflowInstanceId}/PEDI002/step/StepSender`, {  onSameUrlNavigation: 'reload' }).then(() => {
      this.hideLoadingMask();
      const message = "Workflow.DeleteSucess";
      this.alertService.success(message);
      this.loadWorkflowInstance()
        .subscribe(() => {
          if (this.isWorkflowSubmited) {
            //this.addDocumentsToNotifications();
            this.documentsObservableService.setWorkflowSubmited(true);
          } else {
            this.saveBeneficiariesValues();
            this.documentsObservableService.setWorkflowSubmited(false);

            if (this.workflowCode == "PEDI002" || this.workflowCode == "PEDI002A" || this.workflowCode == "PEDI002B") { // para precarregar os documentos
              this.loadDocumentNotificationPEDI002()
            }
          }
          this.currentStep.renavigateToRoot();
          this.hideLoadingMask();
        });
    });
  }

  /**
 * Delete instance of workflow
 *
 * @remarks
 * This is the workflow module interface.
 *
 */
  public onDeleteWorkflowData(event: Event) {
    event.preventDefault();
    //DELETE DATA
    let confirmMessage = "PrestacoesMorte.Mensagens.ApagarPedido";

    var confirmDeleteModal = <models.BaseModalVM>{ isError: false, message: confirmMessage };
    this.modalService.showModals([confirmDeleteModal]).subscribe(result => {
      if (!result)
        return;

      //console.log(`Delete workflow intance: ${this.workflowInstanceId}`)
      this.loadingMaskService.setShowLoading(true, false);
      this.http.post('api/Workflow/DeleteWorkflowInstance_PM', null, { params: { workflowInstanceId: this.workflowInstanceId } }
      ).subscribe((wf: models.WorkflowStatusVM) => {
        if (wf.stateCode == "OK") {
          this.documentsObservableService.removeAllNotifications();                  
          this.reloadPage();
        } else {
          this.loadingMaskService.setShowLoading(false);
          this.alertService.error(wf.message);
          return;
        }
        
      }, error => {
        //this.alertService.error("Workflow.DeleteError");
        console.error(error);
        this.hideLoadingMask();
      })
    });
  }


  /**
 * Submit current workflow data to CGA systems.
 *
 * @remarks
 * Submits the current workflow data to CGA systems.
 *
 */
  public onSubmit(event: Event, btn: HTMLButtonElement) {
    //Validar se existem step anteriores não validados
    var stepInvalid = false;

    for (var index = 0; index < this.currentStepIndex; index++) {
      if (this.steps[index].stateCode == "PV" || this.steps[index].stateCode == "E") {
        stepInvalid = true;
        break;
      }
    }

    if (stepInvalid && !this.isReturn) {
      this.alertService.error("Existem passos anteriores que não se encontram validados. Por favor complete e valide a informação.");
      window.scrollTo(0, 0);
      this.hideLoadingMask();
      this.isDisabled = (!this.isLastStep) ? false : true;
      return;
    }

    //REFRESH DATA FROM STEPS
    this.writeToLog('WorkFlow Instance: ' + this.workflowInstanceId + ' <-> ' + this.workflowCode + ' | WorkComponent | onSubmit -> RefreshWorkFlowDataFromUI', LogType.Debug);
    this.RefreshWorkFlowDataFromUI();

    Object.keys(this.cgaWorkflowForm.controls).forEach(controlKey => {
      this.cgaWorkflowForm.controls[controlKey].markAsTouched();
    })

    if (this.cgaWorkflowForm.invalid)
      return;

    btn.disabled = true;
    var syncDocsvalidated = false;
    this.loadingMaskService.setShowLoading(true, false);

    const needsRevision = this.currentStep.getWorkflowNeedsRevision();

    if (!needsRevision.revisionNeeded) {
      //VALIDATE CURRENT STEP
      this.loadingMaskService.setShowLoading(true, false, false,true);
      this.validateWorkflowData().pipe(
        filter(() => !this.steps.some(x => x.stateCode !== StepStateCodes.valid && x.stateCode !== StepStateCodes.dOverlap) || this.isReturn),
        // Save workflow data
        switchMap(() => this.http.post<void>('api/Workflow/SaveWorkflowInstance_PM', this.workflowInstance, { params: { workflowInstanceId: this.workflowInstanceId, workflowCode: this.workflowCode } })),
        filter((result) => {
          const res: models.WorkflowStatusVM = (<any>result) as models.WorkflowStatusVM;
          if (res.stateCode == "E") {
            this.alertService.error(res.message);
            btn.disabled = true;
            this.hideLoadingMask();
            return false;
          }
    
          return true;
        }),
        tap((result) => {

          this.isReturn = false
        }
        ),
        // Synch documents if needed
        switchMap(() => {
          //TODO: Temos que ver com a equipa se necessitar de revisão
          if (true || this.workflowTemplate.mandatory || (!this.workflowTemplate.mandatory && this.isWorkflowOnSubscriber && !needsRevision.revisionNeeded)) {

            return this.http.get("api/Workflow/GetIfedorchav", { params: { workflowInstanceId: this.workflowInstanceId }, responseType: 'text' })
              .pipe(
                switchMap(result => this.http.post<void>('api/Documents/SyncDocuments_PM', result, {
                  params: {
                    workflowInstanceId: this.workflowInstanceId,
                    subscriberNumber: this.workflowInstance.StepDeceased.DeceasedIdentification.subscriberNumber,
                    isPrestage: false
                  }
                })
                ));
          }
          else
            return of(null);
        }),
        // Submit workflow
        switchMap(() => {
          syncDocsvalidated = true;
          return this.http.post<void>('api/Workflow/SendWorkflow', needsRevision, {
            params: {
              workflowInstanceId: this.workflowInstanceId, revisionNeeded: needsRevision.revisionNeeded
            }
          })
        }),
        //redirecionar para a home e mostrar mensagem.
        tap(() => {
          const navigationExtras: NavigationExtras = { state: { data: this.getSubmitSuccessMessage(needsRevision.revisionNeeded), code: 'OK' } };
          // The next line is telling header component to hide the help button;
          this.stepDetailsService.workFlowCode.next(null);
          this.documentsObservableService.removeAllNotifications();
          this.hideLoadingMask();
          this.router.navigate(['submited'], navigationExtras);
        }),
        catchError((error) => {
          if (syncDocsvalidated) {
            this.hideLoadingMask();
            return this.http.post<void>('api/Documents/EndDocuments', undefined, {
              params: {
                workflowInstanceId: this.workflowInstanceId,
                subscriberNumber: this.workflowInstance.StepDeceased.DeceasedIdentification.subscriberNumber
              }
            });;
          }
          if (error == undefined)
            this.alertService.error("Não foi possível submeter o seu pedido. Por favor, tente mais tarde.");
          this.hideLoadingMask();
          return of(null);
        })
      ).subscribe(
        () => {
          // The next line is telling header component to hide the help button;
          this.stepDetailsService.workFlowCode.next(null);
          this.documentsObservableService.removeAllNotifications();
          btn.disabled = false;
          this.hideLoadingMask();
        },
        (error) => { btn.disabled = false; },
        () => {
          this.hideLoadingMask();



        }
      );
    } else {
      // Save workflow data
      this.http.post<void>('api/Workflow/SaveWorkflowInstance_PM', this.workflowInstance,
        { params: { workflowInstanceId: this.workflowInstanceId, workflowCode: this.workflowCode } }).pipe(
          tap(() => this.isReturn = false),
          // Submit workflow
          switchMap(() => this.http.post<void>('api/Workflow/SendWorkflow', needsRevision,
            {
              params: {
                workflowInstanceId: this.workflowInstanceId,
                revisionNeeded: needsRevision.revisionNeeded.toString()
              }
            })),
          //redirecionar para a home e mostrar mensagem.
          tap(() => {
            // The next line is telling header component to hide the help button;
            this.stepDetailsService.workFlowCode.next(null);

            const navigationExtras: NavigationExtras = {
              state: { data: this.getSubmitSuccessMessage(needsRevision.revisionNeeded), code: 'OK' }
            };
            this.hideLoadingMask();
            this.documentsObservableService.removeAllNotifications();
            this.router.navigate(['submited'], navigationExtras);
          })
      ).subscribe(
        () => { this.hideLoadingMask(); btn.disabled = false; },
        (error) => { this.hideLoadingMask(); btn.disabled = false; }
      );
    }
  }

  private getSubmitSuccessMessage(revisionNeeded: boolean) {
    // TODO: Ver com BE
    ////Condição é responsável pelo envio da mensagem na submissão dos pedidos, Obrigatórios e Voluntários
    //if (this.workflowTemplate.mandatory || ((this.workflowInstance.statePhase == 'SPS' || this.workflowInstance.statePhase == 'NPS') && !revisionNeeded))
    //  return this.translate.instant((this.workflowCodeParameter.indexOf("PEDI0020") > -1 || this.workflowCodeParameter.indexOf("PEDI008")) > -1 ? 'Workflow.SendToCGAMessageCT' : 'Workflow.SendToCGAMessage');
    ////Condição responsável por enviar a mensagem quando o Pedido é devolvido ao Serviço quando ocorre uma situação de Devolução por parte do Subscritor
    //else if (this.workflowInstance.statePhase == 'NPS' && revisionNeeded)
    //  return this.translate.instant('Workflow.SendToServiceMessage');
    //// Condição responsável por enviar a mensagem quando o Pedido é enviado para o Susbcritor pelo Serviço, quer tenha existido antes uma Devolução ou não
    //else if (!this.workflowTemplate.mandatory && (this.workflowInstance.statePhase == 'NPV' || this.workflowInstance.statePhase == 'NPA'))
    //  return this.translate.instant('Workflow.SendToSubscriberMessage');
    //else
    //  return 'Devido a uma situação imprevista, não foi possível executar a ação pretendida.';
     return this.translate.instant('Workflow.SendToCGAMessage');
  }

  /**
  * Validate given Step
  *
  * @remarks
  * This is an api call
  *
  */
  private async validateStepData() {
    //TODO: Remove after implementation
    let $result = null;
    if (this.workflowInstance.StepDeceased.DeceasedIdentification.identificationDocumentType == 'B') {
      this.workflowInstance.StepDeceased.DeceasedIdentification.identificationNumberFirst = this.workflowInstance.StepDeceased.DeceasedIdentification.identificationNumberFirst?.replace(/^0+/, '');
    }
    const valida: models.WorkflowInstancePreStagePM_VM = {
      workflowCode: this.workflowCode,
      deceasedSubscriberNumber: this.workflowInstance.StepDeceased.DeceasedIdentification.subscriberNumber,
      instanceId: parseInt(this.workflowInstanceId),
      novo: null,
      stepCode: this.currentStepCode,
      page: this.currentStepCode,
      loadInfo: null,
      xml: this.workflowInstance

    }; 
      $result = this.http.post<models.WorkflowStepValidationsVM>(`api/Workflow/ValidateStepData_PM`,valida ,
        { params: { workflowInstanceId: this.workflowInstanceId, stepCode: this.currentStepCode, isSubscriber: this.isWorkflowOnSubscriber.toString() } }
      );
    

    return await $result.pipe(
      switchMap((wv: models.WorkflowStepValidationsVM) => {
        this.currentStepDefinition.stateCode = wv.stateCode;
        if (wv.stateCode !== StepStateCodes.valid) {
          if (wv.stateCode === "XE") {
            var errorMessage = "";
          }
          if (wv.stateCode !== "MI" && wv.stateCode !== "XE" && wv.stateCode !== "TE" ) {
            this.showErrorModalAndScroll();
          }
          if (wv.stateCode === "MI" || wv.stateCode === "ME" ) {
            var errorMessage = "";
            if (!isNullOrUndefined(wv.errors) && wv.errors.length > 0)
              errorMessage = wv.errors[0].message;
            else
              errorMessage = wv.message;

            var errorInfoModal = <models.BaseModalVM>{ isError: wv.stateCode === "ME", message: errorMessage };

            return this.modalService.showModals([errorInfoModal]).pipe(
              map(result => {
                //OK no modal informativo result=true, consideramos o Step Validado
                //Cancelar no modal informativo result=false, consideramos o Step Não Validado
                result ? this.currentStepDefinition.stateCode = "V" : this.currentStepDefinition.stateCode = "E";
                if (wv.stateCode === "MI") {
                  this.isDisabled = false;
                }
              })
            );
          }
          else if (wv.errors != null && wv.errors.length> 0   ) {
            wv.errors.forEach(e => this.alertService.error(e.message));
          }
          this.isDisabled = (!this.isLastStep) ? false : true;
        }
        else {
          if (wv.errors) {
            this.externalValidationsService.setStepExternalErrors(wv);
            this.isDisabled = (!this.isLastStep) ? false : true;
          }
          //this.setStepData(this.currentStepCode, wv.stepData[this.currentStepCode]);
        }

        return of(null);
      })
    );
  }

  /**
  * Validate given Step
  *
  * @remarks
  * This is an api call
  *
  */
  private validateWorkflowData() {
    this.alertService.clear();
    return this.http.post<models.WorkflowValidationsVM>(`api/Workflow/ValidateWorkflowData`, this.workflowInstance,
      { params: { workflowInstanceId: this.workflowInstanceId } }
    ).pipe(map((wv: models.WorkflowValidationsVM) => {
      if (isNullOrUndefined(wv.stepValidationsResult))
        wv.stepValidationsResult = [] as models.WorkflowStepValidationsVM[]

      this.workFlowErrors = wv;

      this.externalValidationsService.setExternalErrors(wv);
      //Sets error state in steps that were returned as invalid
      this.markInvalidSteps(wv);

      const currentStepValidation = wv.stepValidationsResult?.find(v => v.stepCode === this.currentStepCode);
      if (currentStepValidation) {
        this.currentStepDefinition.stateCode = currentStepValidation.stateCode;
        if (currentStepValidation.stateCode === StepStateCodes.valid) {
          if (currentStepValidation.errors) {
            currentStepValidation.errors.forEach(e => this.alertService.info(e.message));
          }
        }
        else {
          if (currentStepValidation.errors) {
            currentStepValidation.errors.forEach(e => this.alertService.error(e.message));
          }
        }
      }
      else {
        this.currentStepDefinition.stateCode = StepStateCodes.valid
      }

      if (wv.stepValidationsResult.some(val => val.stateCode !== StepStateCodes.valid && val.stateCode !== "XE")) {
        this.alertService.error("Workflow.ErrorsOnPreviousSteps");
        wv.stepValidationsResult[0].errors.forEach(e => this.alertService.error(e.message));
      }

    }));

  }

  private markInvalidSteps(wv: models.WorkflowValidationsVM) {
    wv?.stepValidationsResult?.forEach(stepValidation => {
      if (stepValidation.stateCode !== StepStateCodes.valid) {
        var stepWithError = this.getStepDefinition(stepValidation.stepCode);
        stepWithError.stateCode = stepValidation.stateCode;
      }
    })
  }

  //GETTER/SETTERS
  public getStepDefinition(stepCode: string): models.StepVM {
    return this.steps.find(s => s.stepCode === stepCode);
  }

  public getStepData(stepCode: string) {
      return this.workflowInstance[this.getStepDefinition(stepCode).stepDataPropertyName];

  }

  public setStepData(stepCode: string, value: {}) {
    //console.log(`JSON Data for step ${stepCode}:`, value);

    var sCards = "";

    var deleteKeys = new Array();
    for (const key in value) {
      if (this.workflowTemplate.steps.find(step => step.stepCode === stepCode).cards.find(c => c.cardCode === key) == undefined) {
        deleteKeys.push(key);
      }
      sCards += key + ";";
    }

    this.writeToLog('WorkFlow Instance: ' + this.workflowInstanceId + ' <-> ' + this.workflowCode + ' | WorkComponent | setStepData | StepCode ' + stepCode + ' | cards: ' + sCards, LogType.Debug);

    if (deleteKeys.length > 0) {
      for (var i = 0; i < deleteKeys.length; i++) {
        delete (value)[deleteKeys[i]];
      }
    }

    var cardCount = 0;
    for (const key in value) {
      cardCount++;
    }

    if (cardCount > 0) {
      this.workflowInstance[stepCode] = value as any;
    }
    else {
      if (this.workflowInstance[stepCode] == undefined) { //Se step novo a ser criado temos que adicionar mesmo sem cartões.
        this.workflowInstance[stepCode] = value as any;
      }
    }
  }

  public get currentStepCode(): string {
    return this.currentStep.currentStepCode;
  };
  protected RefreshWorkFlowDataFromUI() {
    var sCards = Object.keys(this.currentStep.stepData).join(";");
    this.writeToLog('WorkFlow Instance: ' + this.workflowInstanceId + ' <-> ' + this.workflowCode + ' | WorkComponent | RefreshWorkFlowDataFromUI | StepCode ' + this.currentStepCode + ' | Cards: ' + sCards, LogType.Debug);

    this.setStepData(this.currentStepCode, this.currentStep.stepData);
  }

  public getWorkflowState(): string {
    return ""; // this.workflowInstance.statePhase; // TODO: Ver com o BE
  }

  public navigateToRootStep() {
    const nextCode = this.steps[0].stepCode;
    return this.router.navigate(['step', nextCode], {
      relativeTo: this.activeRoute
    });
  }

  public getInstructions() {
    if (!this.cacheService.isMissingHelpLink(this.workflowTemplate.workflowCode)) {
      console.log("Workflow Help Link: ", this.workflowTemplate.workFlowHelpLink);
      this.cgaGetFileForm.nativeElement.action = this.domain;
      this.cgaGetFileForm.nativeElement.submit();
      return false;
    } else {
      const message = this.translate.instant("BaseModal.HelpLinkNotFound");
      this.alertService.error(message);
      return false;
    }

  }
  public hideLoadingMask() {
    this.loadingMaskService.setShowLoading(false);
  }

  public onDeleteWorkflow(event: Event) {
    event.preventDefault();
    //DELETE WORKFLOW
    var confirmMessage = "Workflow.ConfirmDeleteWorkflowGeneric";
    var confirmDeleteModal = <models.BaseModalVM>{ isError: false, message: confirmMessage };
    this.modalService.showModals([confirmDeleteModal]).subscribe(result => {
      if (!result) return;

      this.loadingMaskService.setShowLoading(true, false);
      this.http.post('api/Workflow/TerminateWorkflowInstance_PM', null, { params: { workflowInstanceId: this.workflowInstanceId } }
      ).subscribe((wf: models.WorkflowStatusVM) => {
        this.hideLoadingMask();

        if (wf.stateCode == "OK") {
          this.documentsObservableService.removeAllNotifications();
          const messagemApagado = "WorkflowSearch.TerminatedWorkflowGeneric";
          const navigationExtras: NavigationExtras = { state: { data: messagemApagado, code: 'OK' } };

          // PIT 40803 \\
          const validOption = ['/instancebrowser', '/workflowSearch'];

          const dadosOrigem = this.sessionStorageService.getOrigemPedidoOptionOnCache();

          if (dadosOrigem != null && validOption.includes(dadosOrigem.origemDoAcesso)) {
            this.destinoRouter = dadosOrigem.origemDoAcesso;
          }
          else {
            this.destinoRouter = '/workflowSearch';
          }
          // PIT 40803 \\

          this.router.navigate([this.destinoRouter], navigationExtras);

          
        } else {
          this.loadingMaskService.setShowLoading(false);
          this.alertService.error(wf.message);
          return;
        }
      },
        error => this.hideLoadingMask()
      )
    });
  }

  public onRedirect() {
    this.lastCurrentStep = this.activeRoute.firstChild.snapshot.params['currentStepCode'];
    this.isReturn = true;
    this.showReturnButton = true;
    this.navigateToEnd();
  }


  public navigateToEnd() {
    const lastStep = this.steps[this.steps.length - 1].stepCode;
    return this.router.navigate(['workflow/', this.workflowInstanceId, 'step', lastStep]);
  }

  public menuSideBarClick(currentStep: string, clickFromHtml=false) {

    if (currentStep != this.steps[this.steps.length - 1].stepCode && this.isReturn) {
      this.isReturn = false;
    }

    this.lastCurrentStep = this.activeRoute.firstChild.snapshot.params['currentStepCode'];
    this.nextMenuStep = currentStep;

    if (this.lastCurrentStep != currentStep && !this.isAtendimento && !this.isWorkflowSubmited)
      this.invalidateSteps(clickFromHtml);
  }


  public invalidateSteps(clickFromHtml = false) {

    var lastCurrentStepIndex = this.steps.findIndex(i => { return i.stepCode == this.lastCurrentStep });
    var nextStepIndex = this.steps.findIndex(i => { return i.stepCode == this.nextMenuStep });
    var currentStepCode = this.steps[this.currentStepIndex].stepCode;

    var stepsToInvalidate = "";
    var stepsCodeToRecover = "";

    //Obter o Último Step Validado
    for (var index = this.steps.length - 1; index >= 0; index--) {
      if (this.steps[index].stateCode == "V" || this.steps[index].stateCode == "E" || this.steps[index].stateCode == "MI") {
        lastCurrentStepIndex = index;
        break;
      }
      //if (this.steps[index].stateCode == "PV") {
      //  lastCurrentStepIndex = index - 1;claro
      //  break;
      //}
    }

    //if (this.steps[lastCurrentStepIndex].stateCode == "PV")
    //  lastCurrentStepIndex--;

    //Situação em que se acede ao step mudando o endereço na barra de URL em que ficam para trás steps que não estão em "Por Validar" ou em "Erro" então devemos colocar como ultimo step o step atual.
    if (nextStepIndex > lastCurrentStepIndex) {
      //stepsCodeToRecover = this.steps[lastCurrentStepIndex].stepCode;
      lastCurrentStepIndex = this.steps.findIndex(i => { return i.stepCode == this.lastCurrentStep });
    }

    //Criar string com todos os steps a invalidar
    for (var i = nextStepIndex; i <= lastCurrentStepIndex; i++) {
      stepsToInvalidate += this.steps[i].stepCode + ";";
    }

    if (stepsToInvalidate.length > 0) {
      //Chamar função InvalidaSteps no WorkflowController passando o ID da instância e os Steps a invalidar
      this.http.post('api/Workflow/InvalidaSteps', null, { params: { workflowInstanceId: this.workflowInstanceId, steps: stepsToInvalidate } }
      ).subscribe((result) => {

        if (result != null && result["stateCode"] == "OK") {
          for (var i = nextStepIndex; i <= lastCurrentStepIndex; i++) {
            this.steps[i].stateCode = "E";
          }
        }
        else {
          this.router.navigate(['step', currentStepCode], {
            relativeTo: this.activeRoute
          });
          this.alertService.error(result["message"]);
          window.scrollTo(0, 0);
        }
        if (clickFromHtml) {
          this.loadDocumentNotificationPEDI002();
        }

      });
    }
  }

  public writeToLog(message: string, logType: LogType) {
    var logModel: models.LogModelVM = {
      message: message,
      type: logType
    };
    this.logService.logToBackend(logModel);
  }

  isDocumentationOk(newDocumentList: DocumentVMExtension[], showMessage: boolean = true): boolean {

    // Refresh intitial mandatory list
    const initialMandatory = newDocumentList.filter(el => el.isMandatoryFile?.toString()?.toLowerCase() === 'true')

    let isDocumentsOk: boolean = true;
    // testar os documentos obrigatórios primeiro à procura de inválidos 
    if (initialMandatory.length > 0) {
      initialMandatory.forEach((el: DocumentVMExtension) => {
        if (el.fileID == null || el.fileID == undefined || el.fileID == "0") {
          isDocumentsOk = false;
        }
      });
    }
    // testar os todos os outros documentos  primeiro à procura de inválidos
    let otherDocumentsOk: boolean = true;
    let othersDocs = newDocumentList.filter(
      (el: DocumentVMExtension) => el.isMandatoryFile == null ||
        el.isMandatoryFile == null ||
        el.isMandatoryFile?.toString()?.toLowerCase() === 'false'
    );
    if (othersDocs.length > 0) {
      othersDocs.forEach((el: DocumentVMExtension) => {
        if (el.fileID == null || el.fileID == undefined || el.fileID == "0") {
          otherDocumentsOk = false;
        }
      });
    }
    if (!isDocumentsOk && showMessage) {
      var baseModal = <models.BaseModalVM>{ isError: true, message: "Generic.ErrorOnSentToCGADocuments" };
      this.modalService.showModals([baseModal]).subscribe(result => { });
    } else {
      if (!otherDocumentsOk && showMessage) {
        var baseModal = <models.BaseModalVM>{ isError: true, message: "Generic.ErrorDocuments" };
        this.modalService.showModals([baseModal]).subscribe(result => { });
      }
    }
    return isDocumentsOk && otherDocumentsOk;
  }

  

  //Esta função serve para adicionar as notificações dos documentos quando o pedido é carregado depois de ser criado
  loadDocumentNotificationPEDI002(forceStep: string = null) {

    
    this.isAddingNotifications = true;
    const senderIdentificationName = this.workflowInstance.StepSender?.SenderIdentification?.name;
    const senderIdentificationNIF = this.workflowInstance.StepSender?.SenderIdentification?.NIF;

    const deceasedIdentificationSubscriberName = this.workflowInstance.StepDeceased?.DeceasedIdentification?.subscriberName;
    const deceasedIdentificationSubscriberNIF = this.workflowInstance.StepDeceased?.DeceasedIdentification?.NIF;

    const beneficiaryList = this.workflowInstance.StepBeneficiary?.Beneficiary?.beneficiaryList;
    const existePensaoSobrevivencia = this.workflowInstance.
      StepBeneficiary?.Beneficiary?.beneficiaryList
      .filter(el => el.survivalPensionBenefit?.toString() == 'true').length > 0;
    if (this.isStepCurrentOrBefore("StepSender") || this.isStepAfterOrCurrentForceStep(forceStep)) {
      //if (!isNullOrUndefined(senderIdentificationName) && !isNullOrUndefined(senderIdentificationNIF)) {
      //  const isLegalRepresentativeValidation = this.prestacoesPorMorteValue
      //    .legalRepresentativeValidation(this.workflowInstance.StepSender?.SenderQualification?.isLegalRepresentative);        
      //  this.prestacoesPorMorteValue.changeLegalRepresentativeNotification(
      //    senderIdentificationName,
      //    senderIdentificationNIF,
      //    isLegalRepresentativeValidation);
      //}
    }
    
    if (this.isStepCurrentOrBefore("StepDeceased") || this.isStepAfterOrCurrentForceStep(forceStep)) {
        this.prestacoesPorMorteValue.changeCertidaoNascimentoFalecidoNotification(
          deceasedIdentificationSubscriberName,
          deceasedIdentificationSubscriberNIF,
          true);
        
      // A prova de efectividade mudou a regra, já não pode ser obtida aqui, mas nos beneficiarios
        //const provaEfectividadeValidation = this.prestacoesPorMorteValue
        //  .provaEfetividadeValidation(this.workflowInstance.StepDeceased?.ProfessionalCategory?.hadPensionCGABeforeDeath,
        //    this.workflowInstance.StepDeceased?.ProfessionalCategory?.lastService);
        //this.prestacoesPorMorteValue
        //  .changeProvaEfetividadeNotification(
        //    deceasedIdentificationSubscriberName,
        //    deceasedIdentificationSubscriberNIF,
        //    provaEfectividadeValidation);

      // A prova de efectividade mudou a regra, agora tem que ser obtida aqui, não no falecido
      const provaEfectividadeValidation = this.prestacoesPorMorteValue
        .provaEfetividadeValidation(this.workflowInstance.StepDeceased?.ProfessionalCategory?.hadPensionCGABeforeDeath,
          existePensaoSobrevivencia);
      this.prestacoesPorMorteValue
        .changeProvaEfetividadeNotification(
          deceasedIdentificationSubscriberName,
          deceasedIdentificationSubscriberNIF,
          provaEfectividadeValidation);
      
    }
    
    if (this.isStepCurrentOrBefore("StepBeneficiary") || this.isStepAfterOrCurrentForceStep(forceStep)) {
      beneficiaryList.forEach(item => {
        const beneficiaryIdentificationName = item?.beneficiaryName;
        const beneficiaryIdentificationNIF = item?.NIF;
        const beneficiaryId = item?.beneficiaryID;

        if (!isNullOrUndefined(beneficiaryIdentificationName) &&
          !isNullOrUndefined(beneficiaryIdentificationNIF) && !this.isBeneficiaryRLIndeferida(item)) {




          const faturaOuRecidoDespesaValidation = this.prestacoesPorMorteValue
            .faturaOuRecidoDespesaFuneralValidation(item?.reimbursementFuneralBenefit);
          this.prestacoesPorMorteValue.changeFaturaOuRecidoDespesaFuneralNotification(
            faturaOuRecidoDespesaValidation,
            beneficiaryIdentificationName,
            beneficiaryIdentificationNIF, beneficiaryId);
          

          const certidaoNascimentoRequerenteValidation = this.prestacoesPorMorteValue
            .certidaoNascimentoRequerenteValidation(item?.survivalPensionBenefit, item?.funeralAllowanceBenefit, item?.deceasedRelationship);
          this.prestacoesPorMorteValue.changeCertidaoNascimentoRequerenteNotification(
            certidaoNascimentoRequerenteValidation,
            beneficiaryIdentificationName,
            beneficiaryIdentificationNIF, beneficiaryId);

          const atestadoJuntaFreguesiaValidation = this.prestacoesPorMorteValue
            .atestadoJuntaFreguesiaValidation(item?.survivalPensionBenefit, item?.funeralAllowanceBenefit, item?.deceasedRelationship);
          this.prestacoesPorMorteValue.changeAtestadoJuntaFreguesiaNotification(
            atestadoJuntaFreguesiaValidation,
            beneficiaryIdentificationName,
            beneficiaryIdentificationNIF, beneficiaryId);

          const declCompHonraValidation = this.prestacoesPorMorteValue
            .declCompHonraValidation(item?.survivalPensionBenefit, item?.funeralAllowanceBenefit, item?.deceasedRelationship);
          this.prestacoesPorMorteValue.changeDeclCompHonraNotification(
            declCompHonraValidation,
            beneficiaryIdentificationName,
            beneficiaryIdentificationNIF, beneficiaryId);

          const deathDate = this.workflowInstance.StepDeceased?.DeceasedIdentification?.deathDate;
          const provaEscolarValidation = this.prestacoesPorMorteValue
            .declProvaEscolarValidation(item?.survivalPensionBenefit, item?.funeralAllowanceBenefit, item?.deceasedRelationship
              , item?.dateOfBirth, item?.hasChargeDeceased, deathDate, item?.registrationYear, item?.hasIncapacity);
          this.prestacoesPorMorteValue.changeProvaEscolarNotification(
            provaEscolarValidation,
            beneficiaryIdentificationName,
            beneficiaryIdentificationNIF, beneficiaryId);

          const docComprovativoSSValidation = this.prestacoesPorMorteValue
            .docComprovativoSSValidation(item?.survivalPensionBenefit, item?.funeralAllowanceBenefit, item?.deceasedRelationship
              , item?.dateOfBirth, item?.hasChargeDeceased, item?.hasIncapacity, item?.activeProfessionalSituation);
          this.prestacoesPorMorteValue.changedocComprovativoSSNotification(
            docComprovativoSSValidation,
            beneficiaryIdentificationName,
            beneficiaryIdentificationNIF, beneficiaryId);

          const sentencaValidation = this.prestacoesPorMorteValue
            .sentencaValidation(item?.survivalPensionBenefit, item?.funeralAllowanceBenefit, item?.deceasedRelationship
              , item?.dateOfBirth, item?.hasIncapacity, item?.hasJudicialInterdiction);
          this.prestacoesPorMorteValue.changeSentencaNotification(
            sentencaValidation,
            beneficiaryIdentificationName,
            beneficiaryIdentificationNIF, beneficiaryId);

          const declaracaoIRSValidation = this.prestacoesPorMorteValue
            .declaracaoIRSValidation(item?.survivalPensionBenefit, item?.funeralAllowanceBenefit, item?.deceasedRelationship);
          this.prestacoesPorMorteValue.changeDeclaracaoIRSNotification(
            declaracaoIRSValidation,
            beneficiaryIdentificationName,
            beneficiaryIdentificationNIF, beneficiaryId);

          const declaracaoPensaoAlimentosValidation = this.prestacoesPorMorteValue
            .declaracaoPensaoAlimentosValidation(item?.hasCourtAlimony, item?.survivalPensionBenefit, item?.deceasedRelationship);
          this.prestacoesPorMorteValue.changeDeclaracaoPensaoAlimentosNotification(
            declaracaoPensaoAlimentosValidation,
            beneficiaryIdentificationName,
            beneficiaryIdentificationNIF, beneficiaryId);

          const docPrestacoesFamiliaresValidation = this.prestacoesPorMorteValue
            .docPrestacoesFamiliaresValidation(item?.deceasedRelationship, item?.dateOfBirth, item?.hasIncapacity, item?.survivalPensionBenefit, item.hasChargeDeceased);
          this.prestacoesPorMorteValue.changeDocPrestacoesFamiliaresNotification(
            docPrestacoesFamiliaresValidation,
            beneficiaryIdentificationName,
            beneficiaryIdentificationNIF, beneficiaryId);

          const docPSIValidation = this.prestacoesPorMorteValue
            .docPSIValidation(item?.hasSocialPension);
          this.prestacoesPorMorteValue.changeDocPSINotificationNotification(
            docPSIValidation,
            beneficiaryIdentificationName,
            beneficiaryIdentificationNIF, beneficiaryId);
          
          const certidaoIsensaoIRSValidation = this.prestacoesPorMorteValue
            .certidaoIsensaoIRSValidation(item?.hasIRSExemption);
          this.prestacoesPorMorteValue.changeCertidaoIsensaoIRSNotificationNotification(
            certidaoIsensaoIRSValidation,
            beneficiaryIdentificationName,
            beneficiaryIdentificationNIF, beneficiaryId);

          const comprovativoIBANValidation = this.prestacoesPorMorteValue
            .comprovativoIBANValidation(item?.bankAccount);
          this.prestacoesPorMorteValue
            .changeComprovativoIBANNotification(
              comprovativoIBANValidation,
              beneficiaryIdentificationName,
              beneficiaryIdentificationNIF, beneficiaryId);

          const requerenteHabilitandoValidation = this.prestacoesPorMorteValue
            .requerendoValidation(this.workflowInstance.StepSender.SenderQualification.isServiceOrFunerary);
          this.prestacoesPorMorteValue
            .changeRequerenteHabilitandoNotification(
              requerenteHabilitandoValidation,
              beneficiaryIdentificationName,
              beneficiaryIdentificationNIF, beneficiaryId);
          const legalRepresentativeIsNotSender = !this.workflowInstance.StepSender.SenderQualification.isLegalRepresentative;

          const representacaoLegalValidation = this.prestacoesPorMorteValue
            .legalRepresentativeBeneficiaryValidation(item.hasLegalRepresentation, legalRepresentativeIsNotSender);
          this.prestacoesPorMorteValue
           .changeLegalRepresentativeBeneficiaryNotification(
             representacaoLegalValidation,
             beneficiaryIdentificationName,
             beneficiaryIdentificationNIF,
             beneficiaryId);

          const representacaoLegalCertidaoValidation = this.prestacoesPorMorteValue
            .legalRepresentativeCertidaoBeneficiaryValidation(item.hasLegalRepresentation, legalRepresentativeIsNotSender);
          this.prestacoesPorMorteValue
            .changeLegalRepresentativeCertidaoBeneficiaryNotification(
              representacaoLegalCertidaoValidation,
              beneficiaryIdentificationName,
              beneficiaryIdentificationNIF,
              beneficiaryId);

        }
      })
    }

    this.isAddingNotifications = false;
    
  }





  /// Verify if the step is before the current step
  /// in the template, by the order field thats specified in the step object
  private isStepCurrentOrBefore(stepCode: string): boolean {
    const currentStepCode = this.activeRoute.firstChild.snapshot.params['currentStepCode'];
    const currentOrder = this.workflowTemplate.steps
      .find(st => st.stepCode == currentStepCode).order;
    const stepOrder = this.workflowTemplate.steps
      .find(st => st.stepCode == stepCode).order;
    const result = stepOrder <= currentOrder;
    return result;
  }

  private isStepAfterOrCurrentForceStep(forceStep) {
    if (forceStep==null) {
      return false;
    }
    const currentStepCode = this.activeRoute.firstChild.snapshot.params['currentStepCode'];
    const currentOrder = this.workflowTemplate.steps
      .find(st => st.stepCode == currentStepCode).order;
    const stepOrder = this.workflowTemplate.steps
      .find(st => st.stepCode == forceStep).order;
    const result = stepOrder >= currentOrder;
    return result;

  }

  private isBeneficiaryRLIndeferida(ben: models.BeneficiaryListVM): boolean {
    let result = false;
    if (this.workflowInstance.StepSender.SenderQualification.isLegalRepresentative?.toString() == 'true') {
      if (ben.stateRL == LegalRepresentationState.RepresentaçaoIndeferida) {
        result = true;
      }
    }
    return result;
  }

}
